import { createContext } from 'react';

export default createContext({});



// WEBPACK FOOTER //
// ./src/components/Twitch/AuthorizationContext.js